import { useQuery } from '@tanstack/react-query';
import { useApi } from 'common/hooks/api';
import { size } from 'lodash';

export const useClientsByAgentQuery = ({ options, queryOptions }) => {
  const Api = useApi();

  return useQuery({
    queryKey: ['clients', options],
    queryFn: async () => {
      const response = await Api.getClientsByAgent(options);
      return response.data;
    },
    ...queryOptions,
    cacheTime: 0,
  });
};

export const generateSortOrder = sorting => {
  if (size(sorting) > 0) {
    return `${sorting[0].id} ${sorting[0].desc ? 'DESC' : 'ASC'}`;
  }
  return ['updatedDate DESC', 'id DESC'];
};

export const useClientListCount = where => {
  const Api = useApi();
  return useQuery({
    queryKey: ['clients', 'count', where],
    queryFn: async () => (await Api.getClientsCount(where))?.data?.count ?? 0,
    keepPreviousData: true,
    staleTime: 0,
    refetchOnMount: 'always',
  });
};

export const useClientListPaginated = ({
  filters,
  pagination,
  sorting,
  fields = ['id', 'name', 'email', 'phone', 'agentId', 'updatedDate', 'status', 'archived', 'lastName', 'firstName', 'contact'],
  include = [
    {
      relation: 'agency',
      scope: {
        fields: {
          agencyCode: true,
          name: true,
        },
      },
    },
    {
      relation: 'agent',
      scope: {
        fields: {
          firstName: true,
          lastName: true,
          fullName: true,
          headshotUri: true,
        },
      },
    },
  ],
}) => {
  const Api = useApi();
  const order = generateSortOrder(sorting);
  return useQuery({
    queryKey: ['clients', { filters, pagination, sorting, fields, include }],
    queryFn: async () => {
      const response = await Api.getClientsByAgent({
        where: filters,
        limit: pagination.pageSize,
        skip: pagination.pageIndex * pagination.pageSize,
        order,
        fields,
        include,
      });
      return response?.data;
    },
    staleTime: 0,
    refetchOnMount: 'always',
    keepPreviousData: true,
  });
};
